import {useSyncSkills} from '../../services/hooks';

export function useGetJobsLogic() {
  const {skillsApi, skills} = useSyncSkills();

  return {skillsApi, skills};
}
